import { render, staticRenderFns } from "./Backups.vue?vue&type=template&id=7ab14d87&scoped=true"
import script from "./Backups.vue?vue&type=script&lang=js"
export * from "./Backups.vue?vue&type=script&lang=js"
import style0 from "./Backups.vue?vue&type=style&index=0&id=7ab14d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab14d87",
  null
  
)

export default component.exports